export const createNoneAudioDestinationNodeConstructor = (audioNodeConstructor) => {
    return class NoneAudioDestinationNode extends audioNodeConstructor {
        constructor(context, internalState, nativeAudioNode, audioNodeRenderer) {
            super(context, internalState, nativeAudioNode, audioNodeRenderer);
        }
    };
};
//# sourceMappingURL=/build/es2018/factories/none-audio-destination-node-constructor.js.map